import { AccordionContent, AccordionHeader, AccordionItem, AccordionRoot } from './Accordion';

export const Accordion = {
  Root: AccordionRoot,
  Item: AccordionItem,
  Content: AccordionContent,
  Header: AccordionHeader,
};
